"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessRequestDto = void 0;
class AccessRequestDto {
    id;
    firstName;
    lastName;
    email;
    message;
    createdAt;
    status;
    completedBy;
    rejectionReason;
}
exports.AccessRequestDto = AccessRequestDto;
